import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'convertDate'
})
export class ConvertDate implements PipeTransform {

  transform(value: any, timezone: any): any {
    const format = 'HH:mm';
    /** Returns the formatted date with expected timezone */
    return moment.tz(value, timezone).format(format);
  }

}
